import { translates } from 'translates';
import { registerSplashBtns } from '../../js/splash-btn-service';
// import { metaService } from '../../js/meta-service';
import { setTriggerOnGreySections } from '../../js/grey-section';
import { scrollTrigger } from '../../js/scroll-trigger';
import { notificationService, NotificationType } from '../../js/notification-service';
import {
  isNameValid,
  isEmailValid,
  isAboutValid
} from '../../js/validation';

function initAccardion() {
  const accardionBtns = document.getElementsByClassName('vacancy');

  [...accardionBtns].forEach((btn) => btn.addEventListener('click', () => {
    const vacancy = btn.querySelector('.vacancy-data');
    vacancy.classList.toggle('hidden');
    btn.classList.toggle('active');
  }));
}

/* -------------------------CONTACT US------------------------------- */
const inititialFormValues = {
  vacancy: '',
  name: '',
  email: '',
  about: '',
  file: null
};
let formEl, attachmentWrap, attachment, file;
let isSubmitting = false;
let form = {...inititialFormValues};

function handleContactUs() {
  formEl = document.getElementById('contact_us_form');
  attachmentWrap = formEl.querySelector('#attachment-wrap');
  attachment = formEl.querySelector('#attachment');
  file = formEl.querySelector('#file');
  const submitBtn = formEl.querySelector('#submitBtn');
  const removeBtn = formEl.querySelector('#removeBtn');

  submitBtn.addEventListener('click', onSubmit);
  removeBtn.addEventListener('click', removeAttachment);
  file.addEventListener('change', fileLoaded);
}

function removeAttachment(e) {
  e.stopPropagation();
  e.preventDefault();
  form.file = null;
  attachment.value = '';
  file.value = '';
  attachmentWrap.classList.add('hidden');
}

function fileLoaded(event) {
  if (event.target.files[0]) {
    form.file = event.target.files[0];
    attachmentWrap.classList.remove('hidden');
    attachment.value = event.target.files[0].name;
  }
}

function onSubmit() {
  if (isSubmitting) {
    return;
  }

  let body = new FormData(formEl);

  form = formDataToObject(body);

  if (!isValid()) {
    return;
  }

  sendRequest(body);
}

function isValid() {
  return isNameValid(form) &&
    isEmailValid(form) &&
    isAboutValid(form);
}

function formDataToObject(formData) {
  const formElemKeys = Array.from(formData.keys());

  return Object.fromEntries(
    formElemKeys.map(key => [key, formData.getAll(key)[0]])
  );
}

async function sendRequest(body) {
  isSubmitting = true;

  try {
    const res = await fetch(`${window.API_URL}/vacancies/contact`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body
    });

    isSubmitting = false;

    if (!res.ok) {
      throw new Error(res.message || res.statusText);
    }

    resetForm();

    notificationService.show({
      title: translates.notifications.vacancyForm.success.title,
      description: translates.notifications.vacancyForm.success.description,
      type: NotificationType.Success
    });
  } catch (err) {
    notificationService.show({
      title: translates.notifications.vacancyForm.error.title,
      description: translates.notifications.vacancyForm.error.description,
      type: NotificationType.Error
    });
  }
}

function resetForm() {
  formEl.reset();
  form = {...inititialFormValues};
  attachmentWrap.classList.add('hidden');
}

function goToContactUs() {
  let contactUsBtns = document.querySelectorAll('.respond');
  [...contactUsBtns].forEach((btn) => {
    btn.addEventListener('click', goToContactUsHandle);
  });
}

function goToContactVacancies() {
  let contactUsBtn = document.querySelector('#btnToVacancies');
  contactUsBtn.addEventListener('click', goToContactVacanciesHandle);
}

function goToContactUsHandle() {
  window.location.href = removeQueryParams(window.location.href) + '#contact-us-section-career';
}

function goToContactVacanciesHandle() {
  window.location.href = removeQueryParams(window.location.href) + '#vacancies';
}

/* -------------------------VACANCY------------------------------- */

function removeQueryParams(url) {
  return url.replace(/[?&][^#?&]*|#.*$/, '');
}

function initCopyVacancyLink() {
  const btns = document.querySelectorAll('.vacancy-copy');
  const tooltip = document.querySelector('.copy-tooltip');
  let timeoutId = null;

  btns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const vacancyId = btn.closest('.vacancy').dataset.id;
      const url = removeQueryParams(window.location.href);
      let vacancyUrl = `${url}/${vacancyId}`;
      navigator.clipboard.writeText(`${vacancyUrl}`);
      tooltip.classList.add('active');
      tooltip.style.top = `${btn.offsetTop}px`;
      tooltip.style.left = `${btn.offsetLeft}px`;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        tooltip.classList.remove('active');
      }, 1500);
    });
  })
}

function scrollToVacancy() {
  if (!window.VACANCY_ID) {
    return;
  }

  const el = document.querySelector(`.vacancy[data-id="${window.VACANCY_ID}"]`);

  if (!el) {
    return;
  }

  const vacancy = el.querySelector('.vacancy-data');
  vacancy.classList.toggle('hidden');
  el.classList.toggle('active');

  window.scrollTo(0, el.offsetTop);

  setTimeout(() => {
    window.scrollTo(0, el.offsetTop);
  }, 500);
}

/* -------------------------COMMON------------------------------- */

let splashBtns = [];

function initSplashBtns() {
  splashBtns = document.querySelectorAll('.splash-btn');

  registerSplashBtns(splashBtns);
}

function registerLiveLine(el) {
  scrollTrigger.registerElement(el, {
    start: 'top 20%',
    once: true
  })
  .subscribe(() => {
    el.classList.add('active');
  });
}

function setLiveLine() {
  const liveLines = document.querySelectorAll('.live-line');
  liveLines.forEach((liveLine) => {
    registerLiveLine(liveLine);
  });
}

// metaService.setWebsiteMeta(); // TODO: move to template (actual for SSR only)

addEventListener('DOMContentLoaded', () => {
  initAccardion();
  initSplashBtns();
  initCopyVacancyLink();
  setTriggerOnGreySections({ start: 'top 40%', end: 'bottom center' });
  setLiveLine();
  goToContactUs();
  goToContactVacancies();
  handleContactUs();
});

addEventListener('load', () => {
  scrollToVacancy();
});
